import request from '@/utils/request'
import qs from 'qs'

// 加载款式信息，这里利用axios来发送请求
// 实际上等同于访问了这个接口 (POST)https://jcd.bavlo.com/manage/app/designLayerInfo?designId=
// 其他接口一样道理

export function common () {
  // 加载款式信息
  const LoadDesignInfo = (desNo) => {
    return request({
      url: 'app/designLayerInfo',
      method: 'POST',
      data: qs.stringify({
        'designId':desNo
      })
    })
  }

  // 获取金属web材质参数（用于渲染）
  const LoadMetalWeb = (userId) => {
    return request({
      url: 'app/findMetalWebsByUser',
      method: 'POST',
      data: qs.stringify({
        'userId':userId
      })
    })
  }

  const LoadAllMetals = () => {
    return request({
        url: 'app/desMetalList',
        method: 'POST',
        data: ''
      })
  }

  // 获取宝石web材质列表（用于渲染）
  const LoadGemWeb = (userId) => {
    return request({
        url: 'app/findGemWebsByUser',
        method: 'POST',
        data: qs.stringify({
          'userId':userId
        })
      })
  }

  const LoadAllGems = () => {
    return request({
        url: 'app/desGemList',
        method: 'POST',
        data: ''
      })
  }

  // 加载试戴图
  const LoadModelPicList = (userId, desTypeId) => {
    return request({
        url: 'app/webModelPicList',
        method: 'POST',
        data: qs.stringify({
            'userId':userId,
            'desTypeId':desTypeId
        })
      })
  }

  //加载图片刻印列表
  const GetImageEngraveList = () => {
    return request({
        url: 'app/getImageEngraveByLayerId',
        method: 'POST',
        data: qs.stringify({
            'layerId': layerId,
            'type': type
        })
      })
  }

  // 用户信息
  const LoadUserInfo = (userId) => {
    return request({
        url: 'app/userInfo',
        method: 'POST',
        data: qs.stringify({
          'userId':userId
        })
      })
  }

  // 获取标注列表
  const LoadDesAnnotationList = (desNo) => {
    return request({
        url: 'app/getDesAnnotationByDesignId',
        method: 'POST',
        data: qs.stringify({
          'designId':desNo
        })
      })
  }

  return { LoadDesignInfo , LoadMetalWeb , LoadAllMetals , LoadGemWeb , LoadAllGems , LoadModelPicList , GetImageEngraveList , LoadUserInfo , LoadDesAnnotationList}

}
